export default __webpack_public_path__ + "static/media/how-helping.b27dc9fe.jpg";